// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  max-width: 475px;
}
.nav-link.pending {
  background-color: aqua;
}
#loader {
  position: absolute;
  z-index: 99;
  top: 40%;
  left: 0;
  right: 0;
  text-align: center;
  visibility: hidden;
}
#loader.loading {
  visibility: visible;
}
#fader.loading {
  opacity: 0.5;
  pointer-events: none;
}
.strikethrough {
  text-decoration: line-through;
}
/* tokens */
.token {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  vertical-align: middle;
}
.token .align-x {
  vertical-align: text-bottom;
}
.token a {
  cursor: pointer;
}

/* buttons */
.btn-link {
  padding: 0;
}
.btn-icon {
  cursor: pointer;
  vertical-align: baseline;
}
.schedule-row-actions .btn-icon svg {
  font-size: 1.15rem;
}
.btn-icon.highlight {
  color: orange;
}
.btn-icon:hover {
  color: red;
}
.btn-align {
  margin-top: -5px;
  border: 0;
}
.btn-xs,
.drop-btn-xs button {
  padding: 0.125rem 0.5rem;
}
.btn-xxs {
  padding: 0 0.4rem;
}

/* header buttons */
.header-button {
  border-color: #dee2e6;
  color: black;
}
.header-button:disabled {
  border-color: #ced4da;
  background-color: #e9ecef;
  opacity: 1;
}
.header-button:hover,
.header-button:focus {
  background-color: #e9ecef;
  border-color: #dee2e6;
  color: black;
}
.header-button:active {
  background-color: #e9ecef;
  border-color: #dee2e6;
  color: black;
}

/* icons */
.icon-align {
  vertical-align: text-bottom;
  margin-bottom: 1px;
}
.icon-align-top {
  vertical-align: super;
}
.icon-input {
  position: absolute;
  top: 0.7rem;
  right: 0.7rem;
  color: gray;
}
.icon-input:hover {
  color: rgb(79, 79, 79);
  cursor: pointer;
}

/* search */
.search-align-trash {
  margin-left: -10px;
  margin-top: 10px;
}

/* override bootstrap-typeahead */
.rbt-menu {
  margin-bottom: 0px;
}
.rbt-aux,
.rbt-close,
.rbt-input-main {
  z-index: 0 !important;
}

/* select box placeholders */
select:has(option:disabled:checked[hidden]) {
  color: gray;
}
.select-placeholder {
  border: 1px solid #ced4da;
  border-radius: 5px;
  padding: 6px 6px 6px 12px;
  background-color: #e9ecef;
}
.select-placeholder .spinner-container {
  float: right;
  margin-right: 5px;
}

/* table customization */
.table-scroll {
  height: 400px;
  overflow: auto;
}
.table-scroll table {
  border-collapse: separate;
  border-spacing: 0;
}
.table-scroll table th {
  position: sticky;
  background-color: white;
  border-bottom: 1px solid black;
  top: 0;
}

.table-list td.sm-col {
  width: 0;
  white-space: nowrap;
}
.table-list td.prewrap {
  white-space: pre-wrap;
}
.table-list tr:last-child {
  border-bottom: hidden;
}

.table tr.yellow {
  background-color: #f3f781;
}
.table tr.green {
  background-color: #8fda46;
}
.table tr.red {
  background-color: #f8d7da;
  color: #58151c;
}
.table tr.yellow td,
.table tr.green td,
.table tr.red td {
  background-color: inherit;
  color: inherit;
}

/* bootstrap draggable modal */
.modal-content.hide {
  background-color: transparent;
  border: none;
  pointer-events: none;
}
.modal-content.draggable .modal-header:hover {
  cursor: move;
}

/* work orders - titles/tech modal */
.modal-dialog.workorder-info-modal {
  max-width: calc(100vw - 2rem);
  margin: 1rem auto;
}
.modal-dialog.workorder-info-modal .modal-content.draggable {
  max-height: calc(100vh - 2rem);
}
.modal-dialog.workorder-info-modal .modal-body {
  overflow-y: auto;
}

/* remove invalid input background img */
.form-control.is-valid,
.form-control.is-invalid,
.form-select.is-valid,
.form-select.is-invalid {
  background: none;
  padding-right: inherit;
}

/* other bootstrap overrides */
.list-unstyled {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA,WAAW;AACX;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;AACZ;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;AACA;;;EAGE,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,MAAM;AACR;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,6BAA6B;EAC7B,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;;;;EAIE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB","sourcesContent":[".login {\n  max-width: 475px;\n}\n.nav-link.pending {\n  background-color: aqua;\n}\n#loader {\n  position: absolute;\n  z-index: 99;\n  top: 40%;\n  left: 0;\n  right: 0;\n  text-align: center;\n  visibility: hidden;\n}\n#loader.loading {\n  visibility: visible;\n}\n#fader.loading {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.strikethrough {\n  text-decoration: line-through;\n}\n/* tokens */\n.token {\n  display: inline-block;\n  padding: 0.125rem 0.5rem;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  vertical-align: middle;\n}\n.token .align-x {\n  vertical-align: text-bottom;\n}\n.token a {\n  cursor: pointer;\n}\n\n/* buttons */\n.btn-link {\n  padding: 0;\n}\n.btn-icon {\n  cursor: pointer;\n  vertical-align: baseline;\n}\n.schedule-row-actions .btn-icon svg {\n  font-size: 1.15rem;\n}\n.btn-icon.highlight {\n  color: orange;\n}\n.btn-icon:hover {\n  color: red;\n}\n.btn-align {\n  margin-top: -5px;\n  border: 0;\n}\n.btn-xs,\n.drop-btn-xs button {\n  padding: 0.125rem 0.5rem;\n}\n.btn-xxs {\n  padding: 0 0.4rem;\n}\n\n/* header buttons */\n.header-button {\n  border-color: #dee2e6;\n  color: black;\n}\n.header-button:disabled {\n  border-color: #ced4da;\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.header-button:hover,\n.header-button:focus {\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n  color: black;\n}\n.header-button:active {\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n  color: black;\n}\n\n/* icons */\n.icon-align {\n  vertical-align: text-bottom;\n  margin-bottom: 1px;\n}\n.icon-align-top {\n  vertical-align: super;\n}\n.icon-input {\n  position: absolute;\n  top: 0.7rem;\n  right: 0.7rem;\n  color: gray;\n}\n.icon-input:hover {\n  color: rgb(79, 79, 79);\n  cursor: pointer;\n}\n\n/* search */\n.search-align-trash {\n  margin-left: -10px;\n  margin-top: 10px;\n}\n\n/* override bootstrap-typeahead */\n.rbt-menu {\n  margin-bottom: 0px;\n}\n.rbt-aux,\n.rbt-close,\n.rbt-input-main {\n  z-index: 0 !important;\n}\n\n/* select box placeholders */\nselect:has(option:disabled:checked[hidden]) {\n  color: gray;\n}\n.select-placeholder {\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n  padding: 6px 6px 6px 12px;\n  background-color: #e9ecef;\n}\n.select-placeholder .spinner-container {\n  float: right;\n  margin-right: 5px;\n}\n\n/* table customization */\n.table-scroll {\n  height: 400px;\n  overflow: auto;\n}\n.table-scroll table {\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.table-scroll table th {\n  position: sticky;\n  background-color: white;\n  border-bottom: 1px solid black;\n  top: 0;\n}\n\n.table-list td.sm-col {\n  width: 0;\n  white-space: nowrap;\n}\n.table-list td.prewrap {\n  white-space: pre-wrap;\n}\n.table-list tr:last-child {\n  border-bottom: hidden;\n}\n\n.table tr.yellow {\n  background-color: #f3f781;\n}\n.table tr.green {\n  background-color: #8fda46;\n}\n.table tr.red {\n  background-color: #f8d7da;\n  color: #58151c;\n}\n.table tr.yellow td,\n.table tr.green td,\n.table tr.red td {\n  background-color: inherit;\n  color: inherit;\n}\n\n/* bootstrap draggable modal */\n.modal-content.hide {\n  background-color: transparent;\n  border: none;\n  pointer-events: none;\n}\n.modal-content.draggable .modal-header:hover {\n  cursor: move;\n}\n\n/* work orders - titles/tech modal */\n.modal-dialog.workorder-info-modal {\n  max-width: calc(100vw - 2rem);\n  margin: 1rem auto;\n}\n.modal-dialog.workorder-info-modal .modal-content.draggable {\n  max-height: calc(100vh - 2rem);\n}\n.modal-dialog.workorder-info-modal .modal-body {\n  overflow-y: auto;\n}\n\n/* remove invalid input background img */\n.form-control.is-valid,\n.form-control.is-invalid,\n.form-select.is-valid,\n.form-select.is-invalid {\n  background: none;\n  padding-right: inherit;\n}\n\n/* other bootstrap overrides */\n.list-unstyled {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
